module.exports = __webpack_public_path__ + "static/media/2-ily-luke-07_14_2020.d66a7c2a.jpg";